/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_No_Teams_FoundInputs */



/**
* | output |
* | --- |
* | "No teams found." |
*
* @param {Spaces_No_Teams_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_no_teams_found = /** @type {((inputs?: Spaces_No_Teams_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_No_Teams_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Teams gefunden.")
	return /** @type {LocalizedString} */ ("No teams found.")
});